export const constants = {
  CLICK_HERE_TXT: "click here",
  BANNER_TXT_MSG: `Saudi National Day is an oppurtunity to reflect on the principles that have shaped the Kingdom's remarkable journey. You have played a critical role. This is a powerful reminder that true strenght lies in its people. Thankyou for your resilience, dedication and contributions`,
  WHATSAPP_MSG: ` and to send a WhatsApp message `,
  ANALYTICS_EVENTS: {
    LGOIN_PAGE_VISIT: "saaya_login_page_visit",
    LOGIN_BTN_CLICKED: "saaya_login-btn-cliked",
    LANDING_PAGE_VISIT: "saaya_landing_page_visit",
    ACCESS_CODE_SUCCESS: "saaya_access_code_success",
    ACCESS_CODE_FAILURE: "saaya_access_code_failure",
    FILTER_SELECTED: "saaya_filter_selected",
    LANGUAGE_SELECTED: "saaya_language_selected",
    CLICKED_RESOURCE: "saaya_clicked_resource",
    CLICK_HERE_CLICKED: "saaya_click_here_btn_cliked",
    CONTACT_US_BTN_CLICKED: "saaya_contact_us_btn_clicked",
    VIDEO_CALL_BTN_CLICKED: "saaya_video_call_btn_clicked",
    WHATSAPP_BTN_CLICKED: "saaya_whatsapp_btn_clicked",
    RESOURCES_BTN_CLICKED: "saaya_resources_btn_clicked",
    WHO_BTN_CLICKED: "saaya_WHO5_btn-cliked",
    PRIVACY_BTN_CLICKED: "saaya_privacy_btn_clicked",
    USE_BROWSER_LINK_BTN: "saaya_use_browser_link_btn_clicked",
    DOWNLOAD_APP_LINK_BTN: "saaya_download_app_link_btn_clicked",
    DOWNLOAD_IOS_APP_LINK_BTN: "saaya_download_ios_app_link_btn_clicked",
  },
};
